import React from "react";
import "../../Styles/ModalNeshan.css";

const ModalNeshan = ({ img, title,mavared1,mavared2, text }) => {
    return (
        <div className="ModalNeshan-help">
            <div className="ModalNeshan-inside-help">
                <div className="ModalNeshan-inside-help-top">
                    <div className="ModalNeshan-inside-help-top-image">
                        <img className="ModalNeshan-inside-help-top-image-img" src={img} />
                    </div>
                    <div className="ModalNeshan-inside-help-top-div-text">
                        <p className="ModalNeshan-inside-help-top-text number-font">
                            {title}
                        </p>
                    </div>


                </div>

                <div className="ModalNeshan-inside-help-bottom">

                    <div className="ModalNeshan-inside-help-bottom-item">

                        <p className="ModalNeshan-inside-help-bottom-item-text">
                            <img style={{marginLeft: "10 px"}} className="ModalNeshan-inside-help-bottom-item-img" src="/imgs/Bashgah/neshan-tik.svg" />
                            {mavared1}
                           
                        </p>
                    </div>

                    <div className="ModalNeshan-inside-help-bottom-text-div">
                        <p className="ModalNeshan-inside-help-bottom-text">
                            {text}
                        </p>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default ModalNeshan;